import { useEffect, useState } from "react";
import { NavLink, Outlet } from "react-router-dom";
import {
  Bell,
  LayoutDashboard,
  Search,
  Ticket,
  UserRound,
} from "lucide-react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import { Toaster } from "@/components/ui/sonner";

const MOBILE_NAV = [
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: LayoutDashboard,
  },
  {
    to: "/tickets",
    label: "Tickets",
    icon: Ticket,
  },
  {
    to: "/tickets",
    label: "Search",
    icon: Search,
    search: true,
  },
  {
    to: "/notifications",
    label: "Alerts",
    icon: Bell,
  },
  {
    to: "/profile",
    label: "Profile",
    icon: UserRound,
  },
];

export default function AppShell({ children }) {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = mobileSidebarOpen ? "hidden" : "";

    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileSidebarOpen]);

  return (
    <div className="min-h-screen bg-background subtle-grid">
      <div className="flex min-h-screen">
        <Sidebar
          mobileOpen={mobileSidebarOpen}
          onMobileClose={() => setMobileSidebarOpen(false)}
        />

        <div className="flex min-w-0 flex-1 flex-col">
          <Topbar onMenuClick={() => setMobileSidebarOpen(true)} />

          <main
            className="flex-1 overflow-x-hidden px-3 pb-24 pt-4 sm:px-5 lg:p-6"
            data-testid="app-main"
          >
            {children || <Outlet />}
          </main>
        </div>
      </div>

      <MobileBottomNavigation />

      <Toaster
        position="top-right"
        richColors
        closeButton
        duration={4000}
      />
    </div>
  );
}

function MobileBottomNavigation() {
  return (
    <nav
      aria-label="Mobile navigation"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 px-2 pb-[max(0.5rem,env(safe-area-inset-bottom))] pt-2 backdrop-blur-xl lg:hidden"
    >
      <div className="mx-auto grid max-w-lg grid-cols-5 gap-1">
        {MOBILE_NAV.map((item) => {
          const Icon = item.icon;

          return (
            <NavLink
              key={`${item.label}-${item.to}`}
              to={item.search ? "/tickets?focus=search" : item.to}
              className={({ isActive }) =>
                `flex min-w-0 flex-col items-center justify-center gap-1 rounded-lg px-1 py-2 text-[10px] transition-colors ${
                  isActive && !item.search
                    ? "bg-[#d4af37]/10 text-[#e5c158]"
                    : "text-muted-foreground hover:bg-white/[0.03] hover:text-foreground"
                }`
              }
            >
              <Icon className="h-4 w-4" />
              <span className="max-w-full truncate">{item.label}</span>
            </NavLink>
          );
        })}
      </div>
    </nav>
  );
}
